import {Box as MantineBox} from '@mantine/core';

/**
 * Layout box — design-layer pass-through over Mantine `Box`.
 * @registry Pass-through Mantine Box; import this instead of @mantine/core outside src/design.
 */
export const Box = MantineBox;
